module.exports = __webpack_public_path__ + "img/系统特点.9ba22685.jpg";